/* Kaddanse — fiche produit : sommaire, total dans le bouton POWER, onglets du
   rayon d'à côté, libellé du dépliage de description (deck v2, 18.08).

   Tout vit dans assets/ (piège du morph Horizon : un <script> inline réinjecté
   ne s'exécute jamais). Rien n'est masqué par ce fichier : sans JavaScript, la
   page reste entière et lisible — le JS n'ajoute que du confort.

   L'AJOUT PANIER des accessoires cochés vit dans kdd-panier.js (module ES qui
   porte déjà l'événement panier officiel du thème). */
(function () {
  'use strict';

  /* ═══════════════ 1. Sommaire de la description ═══════════════
     Le contenu SEO reste INTACT : on lit les H2 déjà présents et on pose un
     sommaire ancré au-dessus. Moins de 3 chapitres → on ne pose rien. */
  function slug(t) {
    return t
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60);
  }

  function poserSommaire() {
    if (document.querySelector('.kdd-sommaire')) return;
    // La description vit désormais dans sa propre section (kdd-desc).
    var blocs = document.querySelectorAll(
      '.kdd-bb__desc-corps, .kdd-desc__corps, .product-information .text-block, .product-information .rte, .product-details .text-block'
    );
    var cible = null;
    for (var i = 0; i < blocs.length; i++) {
      if (blocs[i].querySelectorAll('h2').length >= 3) {
        cible = blocs[i];
        break;
      }
    }
    if (!cible) return;

    var h2s = cible.querySelectorAll('h2');
    var nav = document.createElement('nav');
    nav.className = 'kdd-sommaire';
    nav.setAttribute('aria-label', 'Sommaire de la description');
    var titre = document.createElement('p');
    titre.className = 'kdd-sommaire__titre';
    titre.textContent = 'Dans cette fiche';
    nav.appendChild(titre);
    var ul = document.createElement('ul');
    Array.prototype.forEach.call(h2s, function (h2, i) {
      if (!h2.id) h2.id = 'chapitre-' + (slug(h2.textContent) || i);
      h2.style.scrollMarginTop = '110px'; // le scroll vit dans .page-wrapper
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h2.id;
      a.textContent = h2.textContent;
      a.setAttribute('data-kdd-event', 'produit_sommaire');
      li.appendChild(a);
      ul.appendChild(li);
    });
    nav.appendChild(ul);
    h2s[0].parentNode.insertBefore(nav, h2s[0]);
  }

  /* ═══════════════ 2. Le libellé du dépliage ═══════════════
     Deux emplacements possibles : la section pleine largeur (kdd-desc) et,
     depuis le 19.08, la brique en bas de colonne d'achat (kdd-bb__desc). */
  function armerDescriptionBuyBox() {
    var zone = document.querySelector('[data-kdd-descbb]');
    if (!zone || zone.hasAttribute('data-kdd-descbb-arme')) return;
    var box = zone.querySelector('.kdd-bb__desc-box');
    var label = zone.querySelector('[data-kdd-descbb-label]');
    if (!box || !label) return;
    var ouvrir = label.textContent.trim();
    var fermer = zone.getAttribute('data-kdd-descbb-fermer') || 'Replier la description';
    box.addEventListener('toggle', function () {
      label.textContent = box.open ? fermer : ouvrir;
    });
    zone.setAttribute('data-kdd-descbb-arme', '1');
  }

  function armerDescription() {
    var box = document.querySelector('[data-kdd-desc]');
    if (!box || box.hasAttribute('data-kdd-desc-arme')) return;
    var section = box.closest('.kdd-desc');
    var label = box.querySelector('[data-kdd-desc-label]');
    if (!section || !label) return;
    var ouvrir = label.textContent.trim();
    var fermer = section.getAttribute('data-kdd-desc-fermer') || 'Replier la description';
    box.addEventListener('toggle', function () {
      label.textContent = box.open ? fermer : ouvrir;
    });
    box.setAttribute('data-kdd-desc-arme', '1');
  }

  /* ═══════════════ 3. Le total dans le bouton POWER ═══════════════
     Prix de la variante × quantité + accessoires cochés. Le montant est
     recalculé à chaque changement de variante, de quantité ou de case.
     Si la carte des prix manque, on ne pose rien : jamais de faux montant. */
  function euros(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function prixVariante() {
    var carte = document.querySelector('[data-kdd-prix-variantes]');
    if (!carte) return null;
    var table;
    try {
      table = JSON.parse(carte.getAttribute('data-kdd-prix-variantes'));
    } catch (e) {
      return null;
    }
    var form = document.querySelector('product-form-component form, form[action*="/cart/add"]');
    var champ = form && form.querySelector('input[name="id"], select[name="id"]');
    var id = champ && champ.value;
    if (id && table[id] != null) return table[id];
    // Variante unique : la seule valeur de la table fait l'affaire.
    var cles = Object.keys(table);
    return cles.length === 1 ? table[cles[0]] : null;
  }

  function quantite() {
    var form = document.querySelector('product-form-component form, form[action*="/cart/add"]');
    var q = form && form.querySelector('input[name="quantity"]');
    var n = q ? parseInt(q.value, 10) : 1;
    return n > 0 ? n : 1;
  }

  function majTotal() {
    var btn = document.querySelector('.product-information .add-to-cart-button, .product-details .add-to-cart-button');
    if (!btn) return;
    var base = prixVariante();
    if (base == null) return;

    var somme = base * quantite();
    Array.prototype.forEach.call(document.querySelectorAll('[data-kdd-addon]:checked'), function (c) {
      somme += parseInt(c.getAttribute('data-kdd-addon-prix'), 10) || 0;
    });

    var cible = btn.querySelector('.kdd-total');
    if (!cible) {
      cible = document.createElement('span');
      cible.className = 'kdd-total';
      // Le libellé natif vit dans un <span> interne : on ajoute à côté.
      (btn.querySelector('span:not(.kdd-total)') || btn).insertAdjacentElement('afterend', cible);
    }
    cible.textContent = euros(somme);

    /* 16.10 : le prix barré dans le bouton, à côté du total (demande Mathieu).
       Même règle que le prix barré simulé de la fiche (snippets/kdd-promo-test :
       prix ÷ 0,7 monté au ,99). Posé seulement quand la simulation est visible
       sur la page (pastille −30 %), donc jamais de barré fantôme si elle est retirée. */
    var barre = btn.querySelector('.kdd-total-barre');
    if (document.querySelector('.kdd-promo-pill')) {
      var brut = Math.floor((somme * 100 + 69) / 70);
      var cand = Math.floor(brut / 100) * 100 + 99;
      if (cand < brut) cand += 100;
      if (!barre) {
        barre = document.createElement('span');
        barre.className = 'kdd-total-barre';
        cible.insertAdjacentElement('beforebegin', barre);
      }
      barre.textContent = euros(cand);
    } else if (barre) {
      barre.remove();
    }
  }

  /* Les onglets et les flèches du « rayon d'à côté » sont pilotés depuis le
     19.08 par assets/kdd-rayon.js — la section reprend ses classes et ses
     attributs data-bac-*. Le pilote qui vivait ici a été retiré : deux scripts
     sur le même conteneur, c'est un bug qui attend son heure. */

  /* ═══════════════ Armement ═══════════════ */
  function arme() {
    poserSommaire();
    armerDescription();
    armerDescriptionBuyBox();
    majTotal();
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-kdd-addon], input[name="quantity"], input[name="id"], select[name="id"]')) {
      majTotal();
    }
  });
  document.addEventListener('click', function (e) {
    // Les boutons +/- de quantité d'Horizon écrivent la valeur après le clic.
    var c = e.target;
    if (c && c.closest && c.closest('quantity-selector-component, .quantity-selector')) {
      setTimeout(majTotal, 60);
    }
  });
  // Le morph du thème remplace la buy-box au changement de variante.
  if ('MutationObserver' in window) {
    var attente = null;
    var zone = document.querySelector('.product-information') || document.body;
    new MutationObserver(function () {
      if (attente) return;
      attente = setTimeout(function () {
        attente = null;
        majTotal();
      }, 120);
    }).observe(zone, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arme);
  else arme();
  document.addEventListener('shopify:section:load', arme);
})();

/* ── « Le dernier sillon » (15.10, brouillon) ──
   1. Le bouton de la bande déclenche le VRAI bouton d'ajout de la zone chaude :
      même variante, même quantité, même tiroir panier. Délégation sur document
      (la section peut être réinjectée).
   2. Le prix suit la variante choisie, lu dans la carte des prix posée par le
      bloc de réassurance (data-kdd-prix-variantes).
   3. Mobile : la barre d'achat collante s'efface tant que la bande est visible. */
(function () {
  function vraiBouton() {
    return document.querySelector('.product-information .add-to-cart-button, .product-details .add-to-cart-button, product-form-component button[type="submit"]');
  }
  document.addEventListener('click', function (e) {
    var lien = e.target.closest && e.target.closest('[data-kdd-ds-atc]');
    if (!lien) return;
    var b = vraiBouton();
    if (b && !b.disabled) { e.preventDefault(); b.click(); }
  });

  function euros(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  function majPrix() {
    var cible = document.querySelector('[data-kdd-ds-prix]');
    var carte = document.querySelector('[data-kdd-prix-variantes]');
    if (!cible || !carte) return;
    var table; try { table = JSON.parse(carte.getAttribute('data-kdd-prix-variantes')); } catch (err) { return; }
    var champ = document.querySelector('product-form-component form input[name="id"], form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]');
    var id = champ && champ.value;
    if (id && table[id] != null) cible.textContent = euros(table[id]);
  }
  document.addEventListener('change', function () { setTimeout(majPrix, 60); });
  var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(majPrix, 120); })
    .observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['value'] });

  function observer() {
    var bande = document.querySelector('[data-kdd-dernier-sillon]');
    if (!bande || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (ent) {
      document.body.classList.toggle('kdd-ds-visible', ent[0].isIntersecting);
    }, { threshold: 0.15 }).observe(bande);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observer); else observer();
})();

/* ── Visionneuse des photos d'acheteurs (15.10, lot 3) ──
   Un clic sur une photo (mosaïque ou carte) ouvre un <dialog> : la photo en
   grand et l'avis qui l'accompagne. Flèches pour passer aux autres photos,
   Échap ou clic hors de la photo pour fermer. Délégation sur document. */
(function () {
  var dlg, liste = [], pos = 0;
  function photos() {
    var vues = {}, out = [];
    document.querySelectorAll('[data-kdd-vis-photo]').forEach(function (b) {
      var src = b.getAttribute('data-kdd-vis-photo');
      if (vues[src]) return; vues[src] = 1;
      out.push({ src: src, avis: b.getAttribute('data-kdd-vis-ouvrir') });
    });
    return out;
  }
  function creer() {
    if (dlg) return dlg;
    dlg = document.createElement('dialog');
    dlg.className = 'kdd-vis';
    dlg.setAttribute('aria-label', "Photo d'un acheteur");
    dlg.innerHTML = '<button type="button" class="kdd-vis__x" data-kdd-vis-fermer aria-label="Fermer">×</button>' +
      '<div class="kdd-vis__corps"><div class="kdd-vis__img"><button type="button" class="kdd-vis__nav kdd-vis__nav--p" data-kdd-vis-pas="-1" aria-label="Photo précédente">‹</button>' +
      '<img alt="Photo d\'un acheteur"><button type="button" class="kdd-vis__nav kdd-vis__nav--s" data-kdd-vis-pas="1" aria-label="Photo suivante">›</button></div>' +
      '<div class="kdd-vis__avis"></div></div>';
    document.body.appendChild(dlg);
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('[data-kdd-vis-fermer]')) { dlg.close(); return; }
      var pas = e.target.closest('[data-kdd-vis-pas]');
      if (pas) montrer(pos + parseInt(pas.getAttribute('data-kdd-vis-pas'), 10));
    });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') montrer(pos + 1);
      if (e.key === 'ArrowLeft') montrer(pos - 1);
    });
    return dlg;
  }
  function montrer(i) {
    if (!liste.length) return;
    pos = (i + liste.length) % liste.length;
    var p = liste[pos];
    dlg.querySelector('img').src = p.src + (p.src.indexOf('?') > -1 ? '&' : '?') + 'width=1400';
    var art = document.querySelector('[data-kdd-vis-avis="' + p.avis + '"]');
    var zone = dlg.querySelector('.kdd-vis__avis');
    zone.innerHTML = '';
    if (art) {
      var c = art.cloneNode(true);
      c.classList.remove('kdd-ar__c--cache');
      var ph = c.querySelector('.kdd-ar__photos'); if (ph) ph.remove();
      zone.appendChild(c);
    }
    dlg.querySelectorAll('.kdd-vis__nav').forEach(function (n) { n.hidden = liste.length < 2; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-kdd-vis-photo]');
    if (!b || !window.HTMLDialogElement) return;
    e.preventDefault();
    creer(); liste = photos();
    var src = b.getAttribute('data-kdd-vis-photo');
    var i = 0; liste.forEach(function (p, k) { if (p.src === src) i = k; });
    montrer(i);
    dlg.showModal();
  });
})();

/* Cartes d'avis : « Lire la suite » sur les textes coupés (15.10, lot 3). */
(function () {
  function poser() {
    document.querySelectorAll('#kdd-avis .kdd-ar__liste .kdd-ar__texte').forEach(function (t) {
      var c = t.closest('.kdd-ar__c');
      if (!c || c.querySelector('.kdd-ar__suite') || c.classList.contains('is-ouvert')) return;
      if (t.scrollHeight - t.clientHeight < 4) return;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'kdd-ar__suite'; b.textContent = 'Lire la suite';
      t.insertAdjacentElement('afterend', b);
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.kdd-ar__suite');
    if (!b) return;
    b.closest('.kdd-ar__c').classList.add('is-ouvert'); b.remove();
  });
  document.addEventListener('change', function (e) { if (e.target.classList && e.target.classList.contains('kdd-ar__plus-case')) setTimeout(poser, 50); });
  /* 18.10 : « Lire les N autres avis » est un <label> ; le clic donnait le focus à
     la case cachée en tête de liste et la page remontait d'un coup. On coche la
     case sans focus : la page reste en place et les avis se déplient dessous. */
  document.addEventListener('click', function (e) {
    var l = e.target.closest && e.target.closest('.kdd-ar__plus');
    if (!l) return;
    var c = document.getElementById(l.getAttribute('for'));
    if (!c) return;
    e.preventDefault();
    var y = window.scrollY;
    c.checked = true;
    c.dispatchEvent(new Event('change', { bubbles: true }));
    window.scrollTo(0, y);
  });
  window.addEventListener('resize', function () { clearTimeout(window.__kddSuite); window.__kddSuite = setTimeout(poser, 200); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', poser); else poser();
  window.addEventListener('load', poser);
})();

/* Avis réels : filtres de la synthèse (refonte 16.10, modèle Montrelio).
   « Tous » rend la liste d'origine (5 visibles + « Lire les N autres ») ;
   un autre filtre montre tous les avis correspondants et masque le bouton. */
(function () {
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-kdd-ar-filtre]');
    if (!b) return;
    var sec = b.closest('#kdd-avis');
    if (!sec) return;
    var f = b.getAttribute('data-kdd-ar-filtre');
    sec.querySelectorAll('[data-kdd-ar-filtre]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
    var liste = sec.querySelector('.kdd-ar__liste');
    if (!liste) return;
    liste.classList.toggle('is-filtre', f !== 'tous');
    liste.querySelectorAll('.kdd-ar__c').forEach(function (c) {
      var ok = f === 'tous' ||
        (f === 'photos' && c.getAttribute('data-kdd-ar-photos') === '1') ||
        c.getAttribute('data-kdd-ar-note') === f;
      c.classList.toggle('is-hors-filtre', !ok);
    });
    var vide = sec.querySelector('.kdd-ar__vide');
    if (vide) vide.hidden = !!liste.querySelector('.kdd-ar__c:not(.is-hors-filtre)');
    window.dispatchEvent(new Event('resize'));
  });
})();
